import React, { Component } from 'react';
import * as PropTypes from 'prop-types';

import Modal from 'components/Modal';
import { PopupLoading } from 'modules/Checks/components/PopupLoading';
import Button from 'components/Button';

export class DeleteCardPopup extends Component {
  static propTypes = {
    onOk: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    inProcess: PropTypes.func.isRequired,
  };

  handleOkClick = (e) => {
    e.preventDefault();

    const { onOk } = this.props;

    if (typeof onOk === 'function') {
      onOk();
    }
  };

  handleCancelClick = (e) => {
    e.preventDefault();

    const { onCancel } = this.props;

    if (typeof onCancel === 'function') {
      onCancel();
    }
  };

  render() {
    return (
      <Modal showModal={true} hasCloseIcon={false}>
        {this.props.inProcess && <PopupLoading />}
        <a className="mfp-close popup_close" onClick={this.handleCancelClick} />

        <h2>{'Удалить карту?'}</h2>

        <div className={'form form_buttons right'}>
          <Button
            type={'button'}
            color={'blue'}
            hasWrapper={false}
            onClick={this.handleCancelClick}
          >
            {'Нет'}
          </Button>

          <Button type={'button'} color={'orange'} hasWrapper={false} onClick={this.handleOkClick}>
            {'Да'}
          </Button>
        </div>
      </Modal>
    );
  }
}
